// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__GFxgd","invisible":"Footer_invisible__IE_EH"};